import { render, staticRenderFns } from "./gh.vue?vue&type=template&id=21cc8300&scoped=true&"
import script from "./gh.vue?vue&type=script&lang=js&"
export * from "./gh.vue?vue&type=script&lang=js&"
import style0 from "./gh.vue?vue&type=style&index=0&id=21cc8300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc8300",
  null
  
)

export default component.exports